export default "__VITE_ASSET__UE1Bz_Ix__"